// Dependencies
// -----------------------------------------------
import React from "react";
import ReactI18n from "react-i18n";
import { Link } from "react-router-dom";

const Deposit = ({ currency, amount, bookingCode, moreChargesNeeded }) => {
  const translate = ReactI18n.getIntlMessage;

  return (
    <section className="receipt-info-section">
      <div className="receipt-info-subsection">
        <h3>{translate(`cx.receipt.security_deposit`)}</h3>
        <table className="receipt-pricing-breakdown">
          <tbody>
            <tr className="total">
              <td>Security Deposit Amount</td>
              <td>
                {translate(`global.parsers.currency.${currency}`, {
                  value: parseFloat(amount).toFixed(2),
                })}
              </td>
            </tr>
            {moreChargesNeeded && (
              <tr>
                <td colSpan="2">
                  <Link to={`/my-bookings/payment/${bookingCode}`}>
                    <button className="button">
                      {translate(`cx.receipt.complete_security_deposit`)}
                    </button>
                  </Link>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default Deposit;
